type Size = 'sm' | 'md' | 'lg';

const SQUARE: Record<Size, string> = {
  // Design `.ini` (36px, r12, 12px), Alerts `.ini` (40px, 13px), Students `.ini.lg` (48px, r15, 15px).
  sm: 'h-9 w-9 rounded-[12px] text-xs',
  md: 'h-10 w-10 rounded-[12px] text-[13px]',
  lg: 'h-12 w-12 rounded-[15px] text-[15px]',
};

const CIRCLE: Record<Size, string> = {
  // Design `.av` (36px circle, 13px).
  sm: 'h-9 w-9 text-[13px]',
  md: 'h-10 w-10 text-[13px]',
  lg: 'h-12 w-12 text-[15px]',
};

/** "Abebe Kebede" → "AK"; one word → its first letter; empty → "?". */
export function initialsOf(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return (parts[0].slice(0, 1) + parts[parts.length - 1].slice(0, 1)).toUpperCase();
}

interface Props {
  name: string;
  size?: Size;
  /** `square` = `.ini` (track fill, muted-2 text); `circle` = `.av` (mist fill, ink text). */
  shape?: 'square' | 'circle';
  className?: string;
}

/** Decorative initials tile; the person's name is expected in adjacent text. */
export default function Initials({ name, size = 'sm', shape = 'square', className = '' }: Props) {
  const look = shape === 'circle' ? `rounded-full bg-mist text-ink ${CIRCLE[size]}` : `bg-track text-muted-2 ${SQUARE[size]}`;
  return (
    <span aria-hidden="true" className={`inline-grid flex-none place-items-center font-semibold ${look} ${className}`}>
      {initialsOf(name)}
    </span>
  );
}
